import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { environment } from '../../../environments/environment';
import { AccessGroupService } from '../access-group.service';

@Component({
  selector: 'app-teams-dashboard',
  templateUrl: './teams-dashboard.component.html',
  styleUrls: ['./teams-dashboard.component.scss']
})
export class TeamsDashboardComponent {

  obj_container:any;
  env:any;
  breadcrumbFor:string = '';
  menu_links:any;
  email_verified:boolean = false;
  ngrxAccessGroup:any;

  constructor(public router:Router,public accessgroup:AccessGroupService,public store:Store<any>) { }

  async ngOnInit() {
    this.ngrxAccessGroup = this.store.select<any>((state) => state.profile.accessGroupData);
    this.env = environment;
    var that = this;

    await this.ngrxAccessGroup.subscribe(message => { 
      console.log(message);
      if(message) {
        that.email_verified = true;
        that.menu_links = message;
      }  
      this.breadcrumbFor = 'FS Admin';

      this.obj_container = [
        {
          title:'Teams',
          img_link:`${this.env.s3_upload}/images/dashboard_images/teams/my_teams.png`,
          active: true,
          lm_id:'',
          routerlink: `/myteams`
        },{
          title:'Team Members',
          img_link:`${this.env.s3_upload}/images/dashboard_images/teams/allteammates.png`,
          active: true,
          lm_id:``,
          routerlink: `/all-team-members`
        }
      ]
      console.log(that.obj_container)
    })
  }
}
